import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IBaseDto } from '@http/clients/reporting-app/base-dto.service';
import { OrganizationService } from '@http/clients/reporting-app/organization.service';
import { AwaiterService } from '@services/awaiter.service';
import { ReportsService } from '@services/reports.service';
import { EditorComponentBase, GenericDropdownMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-manager-organization-editor',
    templateUrl: './reporting-manager-organization-editor.component.html',
    styleUrls: ['./reporting-manager-organization-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportingManagerOrganizationEditorComponent
    extends EditorComponentBase<number[] | null>
    implements OnInit, OnDestroy
{
    items: IBaseDto[];
    selectedItems?: IBaseDto[];
    defaultText: string;
    subscription?: Subscription;
    isLoading: boolean;

    constructor(
        private readonly ReportingOrganizationService: OrganizationService,
        private readonly reportsService: ReportsService,
        private readonly awaiter: AwaiterService
    ) {
        super();
        this.items = [];
        this.defaultText = 'Select Manager Organizations';
        this.isLoading = false;
    }

    async ngOnInit(): Promise<void> {
        await this.awaiter.awaitAction(
            'Loading Organizations...',
            async () => {
                this.items = await this.ReportingOrganizationService.getManagedOrganizations();
            },
            (loading) => (this.isLoading = loading)
        );

        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (
                ready &&
                this.items?.length &&
                this.bindingProperty !== null &&
                this.bindingProperty?.length &&
                Array.isArray(this.bindingProperty)
            ) {
                this.selectedItems = this.items.filter(
                    (obj) => this.bindingProperty?.find((id) => id === obj['id']) !== undefined
                );
            } else if (ready && (this.bindingProperty === null || this.bindingProperty === undefined)) {
                this.selectedItems = [];
            }
        });
    }

    onSelectedItemsChange() {
        if (this.selectedItems?.length) {
            this.bindingProperty = this.selectedItems.map((obj) => obj.id);
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
